module.exports = __webpack_public_path__ + "static/media/next.a1e0c98f.svg";